module.exports = __webpack_public_path__ + "OpenSans-Light-963eb32907744d9a0d6b98127162808f.woff";